/**
 * BrandDashboardPresenter
 * --
 */
import React from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  ExpandableContainer,
  Table,
  Statistic,
} from 'components';
import { Button, DatePicker, Input, Radio, Select } from 'antd';
import moment from 'moment';

const BrandDashboardPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const formItem = [
    {
      label: '입점구분',
      form: [
        {
          input: (
            <Radio.Group value={'전체'}>
              <Radio value={'전체'}>전체</Radio>
              <Radio value={'입점업체'}>입점업체</Radio>
              <Radio value={'입점 신청 업체'}>입점 신청 업체</Radio>
              <Radio value={'입점 심사중 업체'}>입점 심사중 업체</Radio>
              <Radio value={'입점 탈퇴 업체'}>입점 탈퇴 업체</Radio>
            </Radio.Group>
          ),
        },
      ],
    },
    {
      label: '업체명',
      form: [
        {
          input: (
            <Select
              size="large"
              value={'전체'}
              options={[{ label: '전체', value: '전체' }]}
              style={{ ...styles.form.input.large }}
            />
          ),
        },
        {
          input: (
            <Input
              size="large"
              style={{ ...styles.form.input.large }}
              placeholder="업체 이름, 코드를 입력해주세요"
            />
          ),
        },
      ],
    },
    {
      label: '사업자 번호',
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="사업자 번호를 입력하세요"
                style={{ ...styles.form.input.large }}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '업체 등록 기간',
      form: [
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              오늘
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1주일
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              3개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              전체
            </Button>
          ),
        },
        {
          input: (
            <>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
            </>
          ),
        },
      ],
    },
  ];

  // NOTE: 테이블 가짜 데이터
  let newData = [];

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>대시보드</Title>

          {/* 요약 */}
          <Content
            maxWidth={'100%'}
            padding={0}
            backgroundColor={'none'}
            style={{ marginBottom: 40, display: 'flex' }}
          >
            {[
              { title: '입점 업체', value: 0, suffix: '업체' },
              { title: '입점 신청 업체', value: 0, suffix: '업체' },
              { title: '심사중인 업체', value: 0, suffix: '업체' },
              { title: '탈퇴한 업체', value: 0, suffix: '업체' },
            ].map((_item, _index) => (
              <div
                key={`${_item.label}-${_index}`}
                style={{
                  background: '#FFFFFF',
                  borderRadius: 4,
                  width: `calc(100% / 4)`,
                  marginRight: _index === 3 ? 0 : 4,
                  padding: 20,
                }}
              >
                <Statistic
                  title={_item.title}
                  value={_item.value}
                  suffix={_item.suffix}
                  direction={'row'}
                  style={{ justifyContent: 'center' }}
                />
              </div>
            ))}
          </Content>
          {/* 요약 끝 */}

          {/* 검색필터 */}
          <Content
            maxWidth={'100%'}
            padding={0}
            backgroundColor={'none'}
            style={{ marginBottom: 40 }}
          >
            <ExpandableContainer borderRadius={4} padding={20}>
              {formItem.map((_item, _index) => (
                <div
                  key={`form_${_index}`}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '10px 0px',
                  }}
                >
                  <div style={{ width: 120, fontSize: 13, fontWeight: 400 }}>
                    <label>{_item.label}</label>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {_item.form.map((_subitem, _subkey) => (
                      <React.Fragment key={`input_${_subkey}`}>
                        {_subitem.input}
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              ))}
            </ExpandableContainer>

            {/* 검색/초기화 버튼 */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                marginTop: 48,
              }}
            >
              <Button
                size="large"
                type="primary"
                style={{ ...styles.button, background: 'var(--primary-color)' }}
              >
                검색
              </Button>
              <Button size="large" style={{ ...styles.button }}>
                초기화
              </Button>
            </div>
            {/* 검색/초기화 버튼 끝 */}
          </Content>
          {/* 검색필터 끝 */}

          {/* 검색결과 */}
          <Content maxWidth={'100%'} borderRadius={4} padding={20}>
            <h4 style={{ fontSize: 14, fontWeight: 500, marginBottom: 12 }}>
              검색 결과 총 <span>0</span>건
            </h4>
            <Table
              data={newData}
              columns={[
                {
                  title: '등록일',
                  key: '등록일',
                  render: (_item) =>
                    moment(_item).format('YYYY-MM-DD HH:mm:ss'),
                },
                {
                  title: '업체명',
                  key: '업체명',
                },
                {
                  title: '아이디',
                  key: '아이디',
                },
                {
                  title: '사업자 번호',
                  key: '사업자번호',
                },
                {
                  title: '회원가입 일',
                  key: 'created_at',
                  render: (item) => moment(item).format('YYYY-MM-DD'),
                },
              ]}
            />
          </Content>
          {/* 검색결과 끝 */}
        </Col>
      </Row>
    </Content>
  );
};

export default BrandDashboardPresenter;
